import assignPositions from "./assignPositions.js";
import pointAllocation from "./pointAllocation.js";

type PlayerInput = Record<string, Record<string, unknown>>;

/**
 * Produces a results object with player positions and scores.
 * @param players - Object with playerId keys and a `points` field representing the score for the round
 * @returns Result object with position and score for the round
 */
function processResults(players: PlayerInput): PlayerInput {
	players = assignPositions(players, { scoreField: "score" });
	Object.keys(players).forEach((playerId) => {
		const position = players[playerId].position as number;
		players[playerId].score = pointAllocation[position] ?? 0;
	});
	return players;
}

export default processResults;
